import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API from "../utils/api";
import "../styling/login.css";
import LoadingMask from "../components/LoadingMask.js";
import FlashMessage from "../components/FlashMessage.js";
import { FaSignInAlt } from "react-icons/fa";
import { useAuth } from "../context/AuthContext";
const Login = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [flashMessage, setFlashMessage] = useState("");
  const [flashType, setFlashType] = useState("success");
  const { login } = useAuth();

  const { user, authLoading } = useAuth();

  useEffect(() => {
    if (authLoading) return; // ⛔ wait

    if (!user) {
      navigate("/login", { replace: true });
    }
  }, [user, authLoading, navigate]);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setFlashType("");
    setFlashMessage("");
    try {
      const res = await API.post("/auth/login", form);

      // Save login info
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("user", JSON.stringify(res.data.user));
      login(res.data.user, res.data.token);
      setFlashType("success");
      setFlashMessage("You are successfully logged in 😃");
      window.dispatchEvent(new Event("storage"));
      // Show success message (green)

      // Redirect after user sees message
      setTimeout(() => {
        navigate("/loanlist");
      }, 500);
    } catch (err) {
      setFlashType("error");
      setFlashMessage("Login failed recheck your credencial ");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <FlashMessage
        message={flashMessage}
        type={flashType}
        duration={3000}
        onClose={() => setFlashMessage("")}
      />
      {loading && <LoadingMask text="Please wait..." />}
      <div className="login-card">
        <h2>Login</h2>

        <form autoComplete="off" onSubmit={handleSubmit}>
          <input
            type="email"
            name="email"
            placeholder="Email"
            autoComplete="new-email"
            value={form.email}
            onChange={handleChange}
            required
          />

          <input
            type="password"
            name="password"
            placeholder="Password"
            value={form.password}
            onChange={handleChange}
            required
          />

          <button
            className="btn btn-primary btn-block"
            type="submit"
            disabled={loading}
          >
            <FaSignInAlt />
            <span>{loading ? "Logging in..." : "Login"}</span>
          </button>
        </form>

        <p
          className="forgot-password"
          onClick={() => navigate("/forgot-password")}
        >
          Forgot Password 🤔 ?
        </p>
        <div className="register-link">
          <p>Don’t have an account? Please contact admin</p>
          <hr />
          <b>
            <p>Email: murariraj.one@gmail.com</p>
            <p>Phone: 7799169804</p>
          </b>
        </div>
      </div>
    </div>
  );
};

export default Login;
